
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsx mdx */


const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope")
  return <div {...props}/>
};

const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`Ein guter Schlaf kann uns in eine ebensolche Stimmung versetzen. Denn ein tiefer Schlaf sorgt dafür, dass die Verbindungsstärke zwischen unseren Nervenzellen ausgeglichen ist, und damit auch die Menge an Neurotransmittern, die zur Übermittlung der Signale zwischen den Nervenzellen ausgeschüttet wird. Das führt dazu, dass wir uns emotional ausgeglichen fühlen. Auch wenn wirksame Medikamente diese Ausschüttungen bei Schlaflosigkeit modulieren können: Der natürliche Schlaf ist durch nichts zu ersetzen. Und er ist die beste Medizin für Geist und Körper.`}</p>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;